import{jsx as e}from"react/jsx-runtime";import{twMerge as t}from"tailwind-merge";
//reference : https://github.com/wishket/frontend-rules/wiki/Grid-System
/**
 * GridLayout 컴포넌트는 그리드 시스템을 구현하는 레이아웃 컴포넌트입니다.
 * 반응형 디자인을 지원하며 모바일, 태블릿, 데스크톱 환경에 따라 다른 그리드 영역을 적용할 수 있습니다.
 * tailwind.config에 정의된 그리드 영역을 사용할 수 있습니다.
 *
 * @component
 * @param {Object} props
 * @param {React.ReactNode} props.children - 그리드 레이아웃 내부에 렌더링될 자식 요소
 * @param {string} [props.gridTemplateAreaClass] - 커스텀 그리드 템플릿 영역을 정의하는 CSS 클래스
 * @param {string} [props.testId] - 테스트를 위한 데이터 테스트 ID
 *
 * @example
 * <GridLayout gridTemplateAreaClass="custom-grid-areas">
 *   <div>Content</div>
 * </GridLayout>
 */
const a=({children:a,gridTemplateAreaClass:r,testId:d})=>/*#__PURE__*/e("div",{className:t("mx-auto grid w-full max-w-container auto-cols-1fr gap-x-5 px-5 desktop:gap-x-6 desktop:px-9",r||"grid-areas-default-mobile tablet:grid-areas-default-tablet desktop:grid-areas-default-desktop"),"data-testid":d,children:a});export{a as GridLayout};
